import { PowderApplication } from "./powderApplication";

export interface IPowderApplication {
	text: string;
	value: PowderApplication;
}

const values: IPowderApplication[] = [
	{
		text: "Innenanwendung",
		value: PowderApplication.Internal,
	},
	{
		text: "Aussenanwendung Industrie",
		value: PowderApplication.ExternalIndustry,
	},
	{
		text: "Aussenanwendung Fassade",
		value: PowderApplication.ExternalFassade,
	},
];

export default values;
